import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type { CareerQuestion, CareerUserResponseSet } from '@backrs_ui/grow-ui/src/models/models';

import { withSettledStartTerm, type SurveyStep } from './survey.util';

const CURRENT_STEP_LABEL: Record<Exclude<SurveyStep, 'CAREER'>, string> = {
  SCHOOL_LEVEL: 'school_level',
  ACCOUNT_FIELDS: 'account_fields',
};

export const useAgentContext = (
  careerQuestions: CareerQuestion[],
  userResponseSet: CareerUserResponseSet,
  currentQuestionIndex: number,
  step: SurveyStep,
) => {
  useRegisterAgentContext({
    kind: 'form',
    description:
      "Multi-step Blueprint quiz wizard that collects the user's career preferences and aspirations.",
    data: {
      currentStep: step === 'CAREER' ? currentQuestionIndex + 1 : CURRENT_STEP_LABEL[step],
      totalSteps: careerQuestions.length,
      isOnSchoolLevelQuestion: step === 'SCHOOL_LEVEL',
      selectedSchoolLevel: userResponseSet.school_level ?? null,
      zipCode: userResponseSet.zip_code ?? null,
      school: userResponseSet.school ?? null,
      graduationYear: userResponseSet.graduation_year ?? null,
      startTerm: withSettledStartTerm(userResponseSet).start_term ?? null,
      startYear: userResponseSet.start_year ?? null,
      currentQuestion: step === 'CAREER' ? (careerQuestions[currentQuestionIndex] ?? null) : null,
      answeredQuestions: userResponseSet.user_responses.length,
    },
  });
};
